export const GET_VERIFIED_MEMBERS_REQUEST = "GET_VERIFIED_MEMBERS_REQUEST";
export const GET_VERIFIED_MEMBERS_SUCCESS = "GET_VERIFIED_MEMBERS_SUCCESS";
export const GET_VERIFIED_MEMBERS_FAIL = "GET_VERIFIED_MEMBERS_FAIL";
export const GET_VERIFIED_MEMBERS_RESET = "GET_VERIFIED_MEMBERS_RESET";
